import { VERSION, BUILD_TIMESTAMP, BUILD_ID } from '@/version';
import axios from 'axios';
import { API_BASE_URL } from "@/config";

export class VersionService {
  /**
   * Gibt die aktuelle Version der Anwendung zurück
   */
  public static getVersion(): string {
    return VERSION;
  }

  /**
   * Gibt den Build-Timestamp zurück
   */
  public static getBuildTimestamp(): string {
    return BUILD_TIMESTAMP;
  }

  /**
   * Fügt einen Versionsparameter zu einer URL hinzu für Cache Busting
   */
  public static addVersionToUrl(url: string): string {
    const [baseUrl, queryString = ''] = url.split('?');
    const params = new URLSearchParams(queryString);

    params.delete('v');
    params.set('v', BUILD_ID);

    const serializedParams = params.toString();
    return serializedParams ? `${baseUrl}?${serializedParams}` : `${baseUrl}?v=${BUILD_ID}`;
  }

  /**
   * Erstellt ein Objekt mit Versionsparametern für API-Requests
   */
  public static getVersionParams(): Record<string, string> {
    return {
      'app-version': VERSION,
      'build-id': BUILD_ID
    };
  }

  /**
   * Prüft, ob eine neue Version auf dem Server verfügbar ist
   */
  public static async checkForUpdates(): Promise<{hasUpdate: boolean, serverVersion: string}> {
    try {
      const response = await axios.get(`${API_BASE_URL}version.php?action=get&t=${Date.now()}`);

      if (response.data && response.data.status === 'success') {
        const serverVersion = response.data.data.version;
        const clientVersion = VERSION;

        return {
          hasUpdate: this.isNewerVersion(serverVersion, clientVersion),
          serverVersion
        };
      }
      return { hasUpdate: false, serverVersion: VERSION };
    } catch (error) {
      console.error('Fehler beim Prüfen auf Updates:', error);
      return { hasUpdate: false, serverVersion: VERSION };
    }
  }

// Ändern von private zu public
public static isNewerVersion(serverVersion: string, clientVersion: string): boolean {
  // Einfache semantische Versionsprüfung (x.y.z)
  const serverParts = serverVersion.split('.').map(Number);
  const clientParts = clientVersion.split('.').map(Number);

  for (let i = 0; i < Math.max(serverParts.length, clientParts.length); i++) {
    const server = serverParts[i] || 0;
    const client = clientParts[i] || 0;

    if (server > client) return true;
    if (server < client) return false;
  }

  return false; // Gleiche Version
}

  /**
   * Führt einen Reload der Anwendung durch
   */
  public static reloadApp(): void {
    // Moderne Version ohne den veralteten booleschen Parameter
    window.location.reload();
  }
}

export default VersionService;
